import { render } from "./TextAlignRichText.vue?vue&type=template&id=5663f530"
import script from "./TextAlignRichText.vue?vue&type=script&lang=js"
export * from "./TextAlignRichText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__